import React, { useState } from 'react';
import { ButtonPrimary } from '@americanexpress/dls-react';
import { useSelector } from 'react-redux';

/* istanbul ignore file */

const AccountEnrollment = () => {
  const vpayTenancyUrl = useSelector((state) => state.getIn(['config', 'vpayTenancyUrl']));
  const internetIdentityBaseUrls = useSelector((state) => state.getIn(['config', 'internetIdentityBaseUrls']));

  const title = 'Account Enrollment';
  const [buyerId, setBuyerId] = useState('');
  const [partnerId, setPartnerId] = useState('');
  const [clientRequestId, setClientRequestId] = useState('');

  let url = `${internetIdentityBaseUrls}/en-us/account/light/login/?target=${vpayTenancyUrl}%2Fcard-selector%3Fpartner_id%3D${partnerId}%26client_request_id%3D${clientRequestId}`;
  if (buyerId) {
    url += `%26buyer_id%3D${buyerId}`;
  }

  const popUpParams = {
    url,
    windowTitle: title,
    height: 715,
    width: 430,
  };

  const invokeWidget = (options) => {
    const y = window.outerHeight / 2 + window.screenY - (options.height / 2);
    const x = window.outerWidth / 2 + window.screenX - (options.width / 2);
    return window.open(options.url, options.windowTitle, `popup=yes, width=${options.width}, height=${options.height}, top=${y}, left=${x}`);
  };

  return (
    <div className="col-xs-12 col-md-12 col-lg-4 margin-center">
      <div className="container pad-2-tb margin-auto">
        <div className="text-align-center margin-2-b">
          <div className="heading-4">Account Enrollment</div>
        </div>
        <div className="card border pad-2-tb pad-4-lr">
          <div className="card-block">
            <div className="margin-2-b form-group">
              <label id="buyerIdLabel" htmlFor="inputBuyerIdLabel" className="label-3" tabIndex="-1">
                Buyer ID
              </label>
              <input
                id="buyerId"
                type="text"
                name="buyerId"
                value={buyerId}
                className="form-control"
                aria-labelledby="buyerIdInput"
                onChange={(e) => setBuyerId(e.target.value)}
              />
            </div>
            <div className="margin-2-b form-group">
              <label id="partnerIdLabel" htmlFor="inputPartnerIdLabel" className="label-3" tabIndex="-1">
                Partner ID
              </label>
              <input
                id="partnerId"
                type="text"
                name="partnerId"
                value={partnerId}
                className="form-control"
                aria-labelledby="partnerIdInput"
                onChange={(e) => setPartnerId(e.target.value)}
              />
            </div>
            <div className="margin-2-b form-group">
              <label id="clientRequestIdLabel" htmlFor="inputClientRequestIdLabel" className="label-3" tabIndex="-1">
                Client Request ID
              </label>
              <input
                id="clientRequestId"
                type="text"
                name="clientRequestId"
                value={clientRequestId}
                className="form-control"
                aria-labelledby="clientRequestIdInput"
                onChange={(e) => setClientRequestId(e.target.value)}
              />
            </div>
            <div className="pad-responsive stack-1 text-align-center margin-1-t">
              <ButtonPrimary
                disabled={!(partnerId && clientRequestId)}
                onClick={() => invokeWidget(popUpParams)}
              >
                Account Enrollment
              </ButtonPrimary>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountEnrollment;
